/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reads_All_NotesInputs */

const en_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All notes`)
};

const ar_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل الملاحظات`)
};

const bn_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব নোট`)
};

const de_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Notizen`)
};

const es_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las notas`)
};

const fr_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les notes`)
};

const pt_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as notas`)
};

const zh_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有注释`)
};

const tr_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm notlar`)
};

const ru_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все примечания`)
};

const pl_reads_all_notes = /** @type {(inputs: Reads_All_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie notatki`)
};

/**
* | output |
* | --- |
* | "All notes" |
*
* @param {Reads_All_NotesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const reads_all_notes = /** @type {((inputs?: Reads_All_NotesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reads_All_NotesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_reads_all_notes(inputs)
	if (locale === "bn") return bn_reads_all_notes(inputs)
	if (locale === "de") return de_reads_all_notes(inputs)
	if (locale === "es") return es_reads_all_notes(inputs)
	if (locale === "fr") return fr_reads_all_notes(inputs)
	if (locale === "pt") return pt_reads_all_notes(inputs)
	if (locale === "zh") return zh_reads_all_notes(inputs)
	if (locale === "tr") return tr_reads_all_notes(inputs)
	if (locale === "ru") return ru_reads_all_notes(inputs)
	if (locale === "pl") return pl_reads_all_notes(inputs)
	return en_reads_all_notes(inputs)
});